import { apiSlice } from './apiSlice';
const OTHEREXPENSES_URL = '/api/otherExpenses';

export const otherExpensesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOtherExpenses: builder.query({
      query: ({ keyword, pageNumber }) => ({
        url: OTHEREXPENSES_URL,
        params: { keyword, pageNumber },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['OtherExpenses'],
    }),
    getOtherExpenseDetails: builder.query({
      query: (otherExpenseId) => ({
        url: `${OTHEREXPENSES_URL}/${otherExpenseId}`,
      }),
      keepUnusedDataFor: 5,
    }),
    createOtherExpense: builder.mutation({
      query: (otherExpenseData) => ({
        url: OTHEREXPENSES_URL,
        method: 'POST',
        body: otherExpenseData,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['OtherExpenses'],
    }),
    updateOtherExpense: builder.mutation({
      query: ({ otherExpenseId, ...data }) => ({
        url: `${OTHEREXPENSES_URL}/${otherExpenseId}`,
        method: 'PUT',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['OtherExpenses'],
    }),
    uploadOtherExpenseImages: builder.mutation({
      query: (formData) => ({
        url: '/api/upload',
        method: 'POST',
        body: formData,
      }),
    }),
    bulkUpdateOtherExpenses: builder.mutation({
  query: (otherExpenseData) => ({
    url: `${OTHEREXPENSES_URL}/bulk`, // Adjust this if your backend uses a different route
    method: 'PUT',
    body: otherExpenseData,
    headers: {
      'Content-Type': 'application/json',
    },
  }),
  invalidatesTags: ['OtherExpenses'],
}),
    deleteOtherExpense: builder.mutation({
      query: (otherExpenseId) => ({
        url: `${OTHEREXPENSES_URL}/${otherExpenseId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['OtherExpenses'],
    }),
    createReview: builder.mutation({
      query: ({ otherExpenseId, ...data }) => ({
        url: `${OTHEREXPENSES_URL}/${otherExpenseId}/reviews`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['OtherExpenses'],
    }),
    getTopOtherExpenses: builder.query({
      query: () => `${OTHEREXPENSES_URL}/top`,
      keepUnusedDataFor: 5,
    }),
  }),
});


export const {
  useGetOtherExpensesQuery,
  useGetOtherExpenseDetailsQuery,
  useCreateOtherExpenseMutation,
  useUpdateOtherExpenseMutation,
  useUploadOtherExpenseImagesMutation,
  useDeleteOtherExpenseMutation,
  useCreateReviewMutation,
  useGetTopOtherExpensesQuery,
  useBulkUpdateOtherExpensesMutation,
} = otherExpensesApiSlice;